export class GestorBloqueio {
    public GestorGuid: string;
    public CedenteGuid: string;
    public Senha: string;
    public GestorLogadoGuid: string;
}
